import { isEqual } from "lodash";
import React, { Children } from "react";
import { useSelector } from "react-redux";
import "components/pages/portfolio/insDeletePortfolioAction.scss";
export const CustomFooter = ({ children }) => {
    const messagesDialog = useSelector((state) => state.messagesDialog, isEqual);
    return (React.createElement("div", { slot: "custom-footer", className: "insDeletePortfolioAction_customFooter", style: {
            display: messagesDialog?.messages?.length > 0 ? "flex" : "none",
            height: 20,
            justifyContent: "flex-end",
            marginBottom: 10,
            marginRight: 10,
            width: 400
        } }, Children.map(children, (child) => React.createElement("div", { className: "insDeletePortfolioAction_customFooterButton" }, child))));
};
